import { createListenerMiddleware } from '@reduxjs/toolkit'
import { deleteCart } from '../cart/cartSlice'
import { clearOffer } from './offersSlice'

/**
 * Promotion evaluation is triggered ONLY from the payment page (CheckoutScreen).
 * Cart mutations (fetchCart, addItem, updateQuantity, removeItem) no longer
 * evaluate promotions — that happens exclusively at the payment entry point.
 */
export const offersListenerMiddleware = createListenerMiddleware()

offersListenerMiddleware.startListening({
  actionCreator: deleteCart.fulfilled,
  effect: async (_action, listenerApi) => {
    listenerApi.dispatch(clearOffer())
  },
})
